import { render, staticRenderFns } from "./Btn.vue?vue&type=template&id=b087f8ca&"
var script = {}
import style0 from "./Btn.vue?vue&type=style&index=0&id=b087f8ca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports